import { Dropdown, InlineDropdown, Search, TabMenu } from '@blend-ed/blendx-ui'
import { injectIntl, intlShape } from '@edx/frontend-platform/i18n'
import { useEffect, useState } from 'react'
import CourseTab from '../../components/CourseTab'
import NotesTab from '../../components/Notes'
import ProgramTab from '../../components/ProgramTab'
import useFetchEnrolledPrograms from '../../hooks/useFetchEnrolledPrograms'
import useLearnerHomeInit from '../../hooks/useLearnerHomeInit'
import messages from './messages'

function Learning({ intl }) {

    const [activeTab, setActiveTab] = useState('Courses')
    const [searchValue, setSearchValue] = useState('')
    const [filterValue, setFilterValue] = useState('')
    const [renderCourses, setRenderCourses] = useState([])
    const [renderPrograms, setRenderPrograms] = useState([])
    const [selectedCourseId, setSelectedCourseId] = useState(null)

    const { data: learnerHomeInit, isLoading: learnerHomeInitLoading, } = useLearnerHomeInit();
    const { data: programs, loading: programsLoading } = useFetchEnrolledPrograms();

    useEffect(() => {
        if (learnerHomeInit && programs) {
            const courses_list = learnerHomeInit.courses;
            const programs_list = programs.map((program) => program.program);

            setRenderCourses(courses_list);
            setRenderPrograms(programs_list);
        }
    }, [learnerHomeInit])

    // search filter function
    useEffect(() => {
        // course search filter
        const filteredCourses = renderCourses.filter((course) => {
            return course.course.courseName.toLowerCase().includes(searchValue.toLowerCase())
        })
        setRenderCourses(filteredCourses)

        // program search filter
        const filteredPrograms = renderPrograms.filter((program) => {
            return program.program.name.toLowerCase().includes(searchValue.toLowerCase())
        })
        setRenderPrograms(filteredPrograms)

        if (searchValue === '' && learnerHomeInit && programs) {
            setRenderCourses(learnerHomeInit.courses)
            setRenderPrograms(programs);
        }
    }, [searchValue, learnerHomeInit, programs])

    // filter filter function
    useEffect(() => {
        // filter courses and programs by A-Z
        if (filterValue === 'atoz') {
            setRenderCourses([...renderCourses].sort((a, b) => a.course.courseName.localeCompare(b.course.courseName, undefined, { numeric: true, sensitivity: 'base' })))
            setRenderPrograms([...renderPrograms].sort((a, b) => a.program.name.localeCompare(b.program.name, undefined, { numeric: true, sensitivity: 'base' })))
        }
        //filter courses and programs by Z-A
        if (filterValue === 'ztoa') {
            setRenderCourses([...renderCourses].sort((a, b) => b.course.courseName.localeCompare(a.course.courseName, undefined, { numeric: true, sensitivity: 'base' })))
            setRenderPrograms([...renderPrograms].sort((a, b) => b.program.name.localeCompare(a.program.name, undefined, { numeric: true, sensitivity: 'base' })))
        }
    }, [filterValue])

    return (
        <main>
            <div className='course-header'>
                <TabMenu>
                    <TabMenu.Item label={intl.formatMessage(messages.courses)} active={activeTab === "Courses"} onClick={() => { setActiveTab("Courses") }} />
                    <TabMenu.Item label={intl.formatMessage(messages.programs)} active={activeTab === "Programs"} onClick={() => { setActiveTab("Programs") }} />
                    <TabMenu.Item label={intl.formatMessage(messages.notes)} active={activeTab === "Notes"} onClick={() => { setActiveTab("Notes") }} />
                </TabMenu>
            </div>

            <div className='course-body'>
                <div className="course-body-header">
                    {activeTab !== "Notes" ? (
                        <>
                            <Search placeholder={intl.formatMessage(messages.search)} onChange={(e) => { setSearchValue(e) }} />
                            <InlineDropdown border onSelect={(e) => { setFilterValue(e.value) }}>
                                <InlineDropdown.Item icon="edit" iconType="fill" label={intl.formatMessage(messages.relevent)} value="relevent" />
                                <InlineDropdown.Item icon="sort-alphabet-asc" iconType="" label={intl.formatMessage(messages.atoz)} value="atoz" />
                                <InlineDropdown.Item icon="sort-alphabet-desc" iconType="" label={intl.formatMessage(messages.ztoa)} value="ztoa" />
                                <InlineDropdown.Item icon="arrow-up-circle" iconType="fill" label={intl.formatMessage(messages.upcoming)} value="upcoming" />
                            </InlineDropdown>
                        </>
                    ) : (
                        <>
                            <Search onChange={(e) => { setSearchValue(e) }} placeholder={intl.formatMessage(messages.search)} />
                            <div>
                                <Dropdown
                                    onClick={(e) => {
                                        setSelectedCourseId(e.value)
                                    }}
                                    placeholder={intl.formatMessage(messages.selectCourse)}
                                    size="xs"
                                    selected={selectedCourseId}
                                >
                                    {renderCourses.map((course) => (
                                        <Dropdown.Item
                                            key={course.courseRun.courseId}
                                            label={course.course.courseName}
                                            value={course.courseRun.courseId}
                                        />
                                    ))}
                                </Dropdown>
                            </div>
                        </>
                    )}
                </div>
                <div className="course-body-content">
                    {activeTab === "Courses" && <CourseTab renderCourses={renderCourses} cardType="progress" isLoading={learnerHomeInitLoading} />}
                    {activeTab === "Programs" && <ProgramTab renderPrograms={renderPrograms} isLoading={programsLoading} />}
                    {activeTab === "Notes" && <NotesTab courseId={selectedCourseId} searchValue={searchValue} />}
                </div>
            </div>
        </main >
    )
}

Learning.propTypes = {
    intl: intlShape.isRequired,
};

export default injectIntl(Learning);
